export function set_applications(state, payload) {
	state.applications = payload.sort(sortAppsCompare);
}

export function set_active_application(state, payload) {
	state.active_application = payload;
}

export function set_application_status(state, status) {
	state.application_status = status;
}

function sortAppsCompare(a, b) {
	if (a.submitted && !b.submitted) {
		return -1;
	}
	if (!a.submitted && b.submitted) {
		return 1;
	}

	if (a.id < b.id) {
		return -1;
	}
	if (a.id > b.id) {
		return 1;
	}

	return 0;
}
